module.exports = __webpack_public_path__ + "static/0071-dc2aa035ef5a5dc28135fe67fdaadbcb.png";